import { chatbotCountryAllowlist } from "./chatbot-country-allowlist";

const getChatbotCountryFromIso3166Alpha3Lower = chatbotCountryAllowlist.resolve;
const getChatbotCountryFromLocale = chatbotCountryAllowlist.resolveFromLocale;

export { getChatbotCountryFromIso3166Alpha3Lower, getChatbotCountryFromLocale };
